import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivityLeaderboardComponent } from './activity-leaderboard.component';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyTableModule } from '@vendasta/galaxy/table';
import { MatTableModule } from '@angular/material/table';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { GalaxyAvatarModule } from '@vendasta/galaxy/avatar';
import { MatSortModule } from '@angular/material/sort';
import { TranslationModule } from '../../i18n';
import { GalaxyFilterChipsModule } from '@vendasta/galaxy/filter/chips';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatBadgeModule } from '@angular/material/badge';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    TranslationModule,
    GalaxyTableModule,
    MatTableModule,
    MatSelectModule,
    MatSortModule,
    GalaxyFormFieldModule,
    GalaxyAvatarModule,
    GalaxyFilterChipsModule,
    MatButtonModule,
    MatIconModule,
    MatBadgeModule,
    ActivityLeaderboardComponent,
  ],
  exports: [ActivityLeaderboardComponent],
  providers: [],
})
export class ActivityLeaderboardModule {}
